export {
  LandingFeatureStoreHub as default,
  getStaticProps,
} from '@cinch-nx/landing-feature-store-hub'
